import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ValidationRuleLevel, ValidationRuleType } from '../types';

type InconsistenciesListProps = {
  rules: ValidationRuleType[];
};

export const InconsistenciesList: React.FC<React.PropsWithChildren<InconsistenciesListProps>> = ({ rules }) => {
  const { t } = useTranslation(['translation']);

  const categories = useMemo(() => {
    return [...new Set(rules.map((rule) => rule.validationRuleGroup))];
  }, [rules]);

  const [activeCategory, setActiveCategory] = useState('');

  return (
    <>
      {activeCategory.length === 0 && (
        <ul className="inconsistencies-categories">
          {categories.map((category, index) => {
            return (
              <li className="inconsistencies-category" key={index} onClick={() => setActiveCategory(category)}>
                <span>
                  <span className="vertical-badges">
                    <span className="error">
                      {rules.filter((rule) => rule.validationRuleGroup === category && rule.validationRuleLevel === 'ERROR').length}
                    </span>
                    <span className="warning">
                      {rules.filter((rule) => rule.validationRuleGroup === category && rule.validationRuleLevel === 'WARNING').length}
                    </span>
                  </span>
                </span>
                <span className="inconsistencies-category-label">{t(`enums.validationRule.${category}`)}</span>
                <span className="inconsistencies-enter-icon">
                  <FontAwesomeIcon icon="angle-right"></FontAwesomeIcon>
                </span>
              </li>
            );
          })}
        </ul>
      )}
      {activeCategory.length > 0 && (
        <>
          <div className="inconsistencies-back" onClick={() => setActiveCategory('')}>
            <span className="inconsistencies-back-icon">
              <FontAwesomeIcon icon="angle-left"></FontAwesomeIcon>
            </span>
            {t('enums.validationRule.menu.back')}
          </div>
          <ul className="inconsistencies-list">
            {rules
              .filter((rule) => rule.validationRuleGroup === activeCategory)
              .map((rule, index) => {
                return (
                  <li
                    className={`inconsistencies-item${rule.validationRuleLevel === ValidationRuleLevel.ERROR ? ' error' : ' warning'}`}
                    key={index}
                  >
                    <Link to={rule.route}>{rule.shortMessage}</Link>
                  </li>
                );
              })}
          </ul>
        </>
      )}
    </>
  );
};
